<template>
    <div>
        <v-card-subtitle>Manage Packages</v-card-subtitle>
        <div class="mb-2 grey lighten-5 pb-2 d-flex flex-row" v-if="boxes.length > 0">
            <v-row class="ma-0">
                <v-col cols="12" md="8">
                    <v-row class="ma-0">
                        <v-col cols="4" class="pa-1">
                            <v-text-field
                                v-model="boxes[0].name"
                                label="Name"
                                :error-messages="getErrorMessage(0, 'name')"
                                @blur="touchField(0, 'name')"
                                >
                            </v-text-field>
                        </v-col>

                        <v-col cols="4" class="pa-1">
                            <v-text-field
                                v-model="boxes[0].sku"
                                label="SKU">
                            </v-text-field>
                        </v-col>

                        <v-col cols="4" class="pa-1">
                            <v-select
                            v-model="boxes[0].item_type"
                            :items="itemTypes"
                            label="Item Type"></v-select>
                        </v-col>

                        <v-col cols="4" class="pa-1">
                            <v-text-field
                                v-model="boxes[0].length"
                                type="number"
                                label="Length (cm)"
                                :error-messages="getErrorMessage(0, 'length')"
                                @blur="touchField(0, 'length')"
                                >
                            </v-text-field>
                        </v-col>
                        <v-col cols="4" class="pa-1">
                            <v-text-field
                                v-model="boxes[0].width"
                                type="number"
                                label="Width (cm)"
                                :error-messages="getErrorMessage(0, 'width')"
                                @blur="touchField(0, 'width')"
                                >
                            </v-text-field>
                        </v-col>
                        <v-col cols="4" class="pa-1">
                            <v-text-field
                                v-model="boxes[0].height"
                                type="number"
                                label="Height (cm)"
                                :error-messages="getErrorMessage(0, 'height')"
                                @blur="touchField(0, 'height')"
                                >
                            </v-text-field>
                        </v-col>
                    </v-row>
                </v-col>

                <v-col cols="12" md="4">
                    <v-row class="ma-0">
                        <v-col cols="6" class="pa-1">
                            <v-text-field
                                v-model="boxes[0].weight"
                                type="number"
                                label="Item Weight (kg)">
                            </v-text-field>
                        </v-col>
                        <v-col cols="6" class="pa-1">
                            <v-text-field
                                v-model="boxes[0].weight_limit"
                                type="number"
                                label="Weight Limit (kg)">
                            </v-text-field>
                        </v-col>
                    </v-row>


                    <v-row class="ma-0">
                        <!-- <v-col cols="6" class="py-0">
                            <v-text-field
                                disabled
                                label="Quantity">
                            </v-text-field>
                        </v-col> -->
                        <v-col cols="6" class="pa-1">
                            <v-text-field
                                v-model="boxes[0].quantity_limit"
                                type="number"
                                label="Quantity Limit"
                                :error-messages="getErrorMessage(0, 'quantity_limit')"
                                @blur="touchField(0, 'quantity_limit')"
                                >
                            </v-text-field>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </div>
    </div>
</template>

<script>
import {PackageStruct} from './../PackingRuleStruct.js';
import { required } from 'vuelidate/lib/validators'
import ValidationHelper from '../PackingRuleValidationHelper'
export default {
    mixins: [ValidationHelper],
    props: {
        itemTypes: Array,
        formData: Object
    },
    data() {
        return {
            boxes: this.formData.packages,
        }
    },
    validations: {
        boxes: {
            $each: {
                name: { required },
                length: { required },
                width: { required },
                height: { required },
                quantity_limit: { required }
            }
        }
    },
    mounted() {
        if(this.boxes.length == 0) {
            this.boxes.push(new PackageStruct({}))
        }
    },
}
</script>
